var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('a-row',{staticClass:"pb-2 center"},[_c('a-col',{attrs:{"span":24}},[_c('img',{staticClass:"center",attrs:{"alt":"loading","src":require("../assets/loading_2.gif")}})])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }